var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnnotateAddNoteNoted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4477_28485",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4477_28485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75644 16.5833C4.38133 16.5833 4.06426 16.4538 3.80523 16.1948C3.5462 15.9357 3.41669 15.6187 3.41669 15.2436V4.75644C3.41669 4.38133 3.5462 4.06426 3.80523 3.80523C4.06426 3.5462 4.38133 3.41669 4.75644 3.41669H12.8237L16.5833 7.17629V15.2436C16.5833 15.6187 16.4538 15.9357 16.1948 16.1948C15.9357 16.4538 15.6187 16.5833 15.2436 16.5833H4.75644ZM4.75644 15.5H15.2436C15.3184 15.5 15.3798 15.476 15.4279 15.4279C15.476 15.3798 15.5 15.3184 15.5 15.2436V8H12V4.5H4.75644C4.68165 4.5 4.62021 4.52404 4.57212 4.57212C4.52404 4.62021 4.5 4.68165 4.5 4.75644V15.2436C4.5 15.3184 4.52404 15.3798 4.57212 15.4279C4.62021 15.476 4.68165 15.5 4.75644 15.5ZM6.20835 13.5833H13.7916V12.5H6.20835V13.5833ZM6.45835 7.75H10V6.66669H6.45835V7.75ZM6.20835 11.0416H13.7916V9.95835H6.20835V11.0416Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 4,
    r: 3.5,
    fill: "#EB5757",
    stroke: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotateAddNoteNoted);
export default __webpack_public_path__ + "static/media/annotate-add-note-noted.c7c85d1ebc36f74d06e957e74f6b8503.svg";
export { ForwardRef as ReactComponent };